/** Alt / aria copy for public gallery—do not expose server filenames. */
export const PUBLIC_PHOTO_ALT = "Photograph";

/** @param {string | undefined} collectionDisplayName e.g. "Bears" */
export function publicPhotoAlt(collectionDisplayName) {
  if (typeof collectionDisplayName === "string") {
    const t = collectionDisplayName.trim();
    if (t) return `Photograph, ${t} collection`;
  }
  return PUBLIC_PHOTO_ALT;
}

/**
 * Prefer editorial title for alt text; fall back to neutral copy (not raw filenames).
 * @param {{ title?: string }} img
 * @param {string | undefined} [collectionDisplayName]
 */
export function galleryImageAlt(img, collectionDisplayName) {
  const t = typeof img?.title === "string" && img.title.trim();
  if (t) return t;
  return publicPhotoAlt(collectionDisplayName);
}
